const regSize = (size) => {
  const reg = /^(\d+)\x(\d+)$/;
  return {
    width: size.replace(reg, '$1') * 1,
    height: size.replace(reg, '$2') * 1,
  };
};

export default regSize;
